import { useTranslation } from "react-i18next";
import { NeuCard } from "../../components/neu/Neu";
import { KpiRow } from "./KpiRow";

const HEADS = ["rank", "employee", "branch", "attendance", "late", "absent", "duties", "tasks", "penalties", "score", "band"];

// جدول ترتيب الأداء الشهري.
export const KpiTable = ({ rows, onOpen }) => {
  const { t } = useTranslation();
  if (!rows.length) {
    return (
      <NeuCard className="p-6 text-center text-sm text-muted-foreground" data-testid="kpi-empty">
        {t("kpi.empty")}
      </NeuCard>
    );
  }
  return (
    <NeuCard className="overflow-x-auto p-3" data-testid="kpi-table">
      <table className="w-full min-w-[820px] text-start">
        <thead>
          <tr className="border-b border-border/60">
            {HEADS.map((head) => (
              <th key={head} className="p-2 text-start text-[11px] font-black text-muted-foreground">
                {t(`kpi.table.${head}`)}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, index) => (
            <KpiRow key={row.user_id} row={row} rank={index + 1} onOpen={onOpen} />
          ))}
        </tbody>
      </table>
    </NeuCard>
  );
};
